'use strict';

module.exports = function (config) {
  config.app.head.script = [{
    src: 'https://cdn.ravenjs.com/3.10.0/raven.min.js',
    crossOrigin: 'anonymous'
  }];

  config.app.prometheusStores.eukdlx.askSid = {
    enabled: true,
    src: 'https://staging-api.asksid.ai/akzo-webchat/wc.min.js'
  };

  config.app.prometheusStores.enlflx.askSid = {
    enabled: true,
    src: 'https://staging-api.asksid.ai/akzo-webchat-enlflx/wc.min.js'
  };

  config.app.prometheusStores.ebelev.askSid = {
    enabled: true,
    src: 'https://staging-api.asksid.ai/akzo-webchat-ebelev/wc.min.js'
  };

  config.app.prometheusStores.enlwdc.askSid = {
    enabled: true,
    src: 'https://staging-api.asksid.ai/akzo-webchat-enlwdc/wc.min.js'
  };

  config.app.prometheusStores.efrdxv.askSid = {
    enabled: true,
    src: 'https://staging-api.asksid.ai/akzo-webchat-efrdxv/wc.min.js'
  };
  config.app.prometheusStores.eukdlx.pickupLocations = { enabled: true };

  config.app.prometheusStores.enlflx.launchTagManager.oneTrustConsentDomainScript = '0898b53b-f85e-4670-a13f-31d7de9f4930-test';

  config.launchEmbedCode = '//assets.adobedtm.com/feb986e74bf7/f95cb7da5d29/launch-e901e932f83f-staging.min.js';
  config.oneTrustConsentEmbedCode = '//cdn.cookielaw.org/scripttemplates/otSDKStub.js';

  return config;
};


//////////////////
// WEBPACK FOOTER
// ./config/staging/index.js
// module id = 2424
// module chunks = 0